import Container from "components/base/Container";
import Image from "components/base/Image";
import MetaHead from "components/base/MetaHead";
import PrivacyPolicyEnContent from "components/sections/PrivacyPolicyEnContent";
import MainContainer from "components/sections/MainContainer";

export default function PrivacyPolicy() {
  const padding = [6, null, 32, null, null];
  const content = <PrivacyPolicyEnContent />;

  return (
    <MainContainer navStyle={{ gradient: false, inverted: false }} footerSmall>
      <MetaHead title="LBL_PRIVACY_META_TITLE" />
      <Container maxWidth="xl" px={padding} py={padding} centerContent m="auto">
        <Image
          src="/images/logo-hill-footer.svg"
          alt="Hill Helicopters logo"
          w="120px"
          height="35px"
          objectFit="contain"
          mb={padding}
        />
        {content}
      </Container>
    </MainContainer>
  );
}
